import type { Ref, ComputedRef, DeepReadonly } from 'vue'
import { ref, computed } from 'vue'

import type { BookMeetingStatus, BookMeetingIncomplete } from './useBookMeeting'
import { isBAMNotSetup, isBAMUnavailable } from './useBookMeeting'
import type { ScheduleSetting } from '@/entities/meeting'

export interface UseBookMeetingDropdown {
  currentUser: Ref<ScheduleSetting>
  users: ComputedRef<ScheduleSetting[]>
}

export function useBookMeetingDropdown(requestSettings: DeepReadonly<Ref<BookMeetingStatus | null>>): UseBookMeetingDropdown {
  const users = computed<ScheduleSetting[]>(() => {
    if (
      !requestSettings.value ||
      isBAMNotSetup(requestSettings.value as BookMeetingStatus) ||
      isBAMUnavailable(requestSettings.value as BookMeetingStatus)
    )
      return []
    return _getUsersWithBookMeetingTurnedOn((requestSettings.value as BookMeetingIncomplete).users)
  })

  const user = ref<ScheduleSetting | null>(null)
  const currentUser = computed({
    get() {
      return user.value ?? users.value[0]
    },

    set(newValue) {
      user.value = newValue
    },
  })

  function _getUsersWithBookMeetingTurnedOn(users: ScheduleSetting[]): ScheduleSetting[] {
    return users.filter(x => x.able_to_book)
  }

  return { currentUser, users }
}
